export const GET_USERS_STATUS = '[USERS] GET USERS STATUS';
export const USERS_UPDATE_USER_STATUS = '[USERS] UPDATE USER STATUS';


export const getStatusUsers = (users) => {

  let allusers = users.map(obj => ({ ...obj}))

  return {
    type: GET_USERS_STATUS,
    data: allusers,
  }    
};

export const updateUserStatusToCalling = (users, userId, calling) => {

  console.log("users  : ", users, userId, calling)
  //let userUpdated = users.filter(obj => parseInt(obj.id) === userId)
  //  userUpdated[0].calling = true
  //const updatedData = users.map(x => (x.id === userId ? { ...x, calling: calling} : x));
  const updatedData = users.map(x => (x.id === userId ? { ...x, busy_in_call: calling} : x));
  //console.log("userUpdated : ", userUpdated)
  //console.log("updatedData : ", updatedData)

  return {
    type: USERS_UPDATE_USER_STATUS,
    data: updatedData,
  }    
};
